<template>
	<iframe :width="width" :height="height" :src="embedUrl" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen v-bind="$attrs"></iframe>
</template>

<script setup>
	const props = defineProps({
		src: {
			type: String,
			required: true,
		},
		width: {
			type: [Number, String],
			default: 560,
		},
		height: {
			type: [Number, String],
			default: 315,
		},
	});

	const embedUrl = computed(() => {
		if (!props.src) return props.src;

		const standardMatch = props.src.match(/[?&]v=([^&]+)/);
		const shortMatch = props.src.match(/youtu\.be\/([^?&]+)/);

		const videoId = standardMatch?.[1] || shortMatch?.[1];

		if (videoId) {
			return `https://www.youtube-nocookie.com/embed/${videoId}`;
		}

		return props.src;
	});
</script>
